import css from './steps.css'
import { add } from '../slicers/addedJobSlicer'
import { useDispatch, useSelector } from 'react-redux';
import { change } from '../slicers/selectedStepSlicer'
import React, { useState, useEffect, useRef } from 'react'
import { add as addStepOne } from '../slicers/stepOneSlicer'

export default function StepOne() {
  const dispatch = useDispatch()
  const callKey = useSelector((state) => state.keySlicer.value)
  const stepOneData = useSelector((state) => state.stepOne.arr)  // ← УЖЕ ВЫБРАННЫЙ СТАНОК ИЗ REDUX
  
  const [step_input, setstep_input] = useState("");
  const [showList, setshowList] = useState(false);
  const [list, setlist] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredList, setFilteredList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const wrapperRef = useRef(null);
  
  //  При загрузке компонента — если станок уже выбран, показываем его номер в поле
  useEffect(() => {
    if (stepOneData?.name) {
      setstep_input(stepOneData.name);
    }
  }, [stepOneData]);
  
  // Закрытие списка при клике вне
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setshowList(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  
  // Фильтрация списка при поиске
  useEffect(() => {
    if (list.length > 0) {
      const filtered = list.filter(item => 
        item.number.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredList(filtered);
    }
  }, [searchTerm, list]);
  
  function JobItem() {
    // Берём номер из Redux (если станок уже выбран) или из поля ввода
    const machineNumber = stepOneData?.number || step_input;
    
    if (machineNumber) {
      setIsLoading(true);
      let xhr = new XMLHttpRequest();
      let url = new URL(`${process.env.REACT_APP_BASEURL}machine/with-machine-operation-types-by-number?machineNumber=${machineNumber}`);
      xhr.open('GET', url, true);
      xhr.setRequestHeader('authtoken', callKey);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.responseType = 'json';
      xhr.send();
      
      xhr.onload = () => {
        setIsLoading(false);
        if (xhr.status == 200) {
          dispatch(addStepOne(xhr.response));
          dispatch(add([8, xhr.response.id]));
          dispatch(add([0, machineNumber]));  // ← сохраняем номер
          dispatch(change(2));
        } else {
          alert('❌ Станок не найден');
        }
      };
      
      xhr.onerror = () => {
        setIsLoading(false);
        alert('❌ Ошибка соединения');
      };
    }
  }

  function callList() {
    setIsLoading(true);
    let xhr = new XMLHttpRequest();
    let url = new URL(`${process.env.REACT_APP_BASEURL}machine/available`);
    xhr.open('GET', url, true);
    xhr.setRequestHeader('authtoken', callKey);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.responseType = 'json';
    xhr.send();
    
    xhr.onload = () => {
      setIsLoading(false);
      if (xhr.status == 200) {
        // Убираем дубликаты по id
        const uniqueMachines = xhr.response.filter((item, index, self) =>
          index === self.findIndex((t) => t.id === item.id)
        );
        setlist(uniqueMachines);
        setFilteredList(uniqueMachines);
      }
    };
    
    xhr.onerror = () => {
      setIsLoading(false);
    };
  }
  
  // Функция выбора станка из списка — СРАЗУ сохраняет в Redux и показывает плашку
  const selectMachine = (machine) => {
    setstep_input(machine.name);
    setSearchTerm("");
    setshowList(false);
    // СРАЗУ сохраняем выбранный станок в Redux
    dispatch(addStepOne(machine));
    dispatch(add([8, machine.id]));
    dispatch(add([0, machine.number]));
  };
  
  // Функция очистки выбранного станка
  const clearSelectedMachine = () => {
    setstep_input("");
    dispatch(addStepOne({}));
    dispatch(add([8, '']));
    dispatch(add([0, '']));
  };
  
  // Функция проверки введённого номера — сохраняет станок после ввода
  const handleInputSubmit = () => {
    if (step_input && !stepOneData?.number) {
      setIsLoading(true);
      let xhr = new XMLHttpRequest();
      let url = new URL(`${process.env.REACT_APP_BASEURL}machine/with-machine-operation-types-by-number?machineNumber=${step_input}`);
      xhr.open('GET', url, true);
      xhr.setRequestHeader('authtoken', callKey);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.responseType = 'json';
      xhr.send();
      
      xhr.onload = () => {
        setIsLoading(false);
        if (xhr.status == 200) {
          // СРАЗУ сохраняем в Redux и показываем плашку
          dispatch(addStepOne(xhr.response));
          dispatch(add([8, xhr.response.id]));
          dispatch(add([0, step_input]));
        } else {
          alert('❌ Станок не найден');
        }
      };
      
      xhr.onerror = () => {
        setIsLoading(false);
        alert('❌ Ошибка соединения');
      };
    }
  };
  
  return (
    <div className="step-container">
      {/* Верхняя панель */}
      <div className="step-header">
        <button className="back-button" onClick={() => dispatch(change(0))}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="#265c9d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>Назад</span>
        </button>
        <div className="step-indicator">
          <span className="step-dot active"></span>
          <span className="step-dot"></span>
          <span className="step-dot"></span>
          <span className="step-dot"></span>
        </div>
      </div>
      
      {/* Заголовок */}
      <div className="step-title-section">
        <h1 className="step-title">Выбор станка</h1>
        <p className="step-subtitle">
          Введите номер станка или выберите из списка доступных
        </p>
      </div>
      
      {/* ПОЛЕ ВВОДА — показывается всегда */}
      <div className="search-section" ref={wrapperRef}>
        <div className="search-box">
          <svg className="search-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="9" cy="9" r="6" stroke="#8A949A" strokeWidth="1.5"/>
            <path d="M13.5 13.5L17 17" stroke="#8A949A" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
          <input
            className="search-input"
            placeholder="Поиск по номеру или названию..."
            value={step_input}
            onClick={() => {
              if (!showList) {
                callList();
                setshowList(true);
              }
            }}
            onChange={(e) => {
              const value = e.target.value;
              setstep_input(e.target.value);
              setSearchTerm(e.target.value);
            }}
            onFocus={() => {
              if (!showList) {
                callList();
                setshowList(true);
              }
            }}
            onBlur={handleInputSubmit}  // При потере фокуса — проверяем и сохраняем станок
          />
          {step_input && (
            <button className="clear-button" onClick={clearSelectedMachine}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <circle cx="8" cy="8" r="7" fill="#CBD5E1"/>
                <path d="M5 5L11 11M11 5L5 11" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
            </button>
          )}
        </div>
        
        {/* Выпадающий список */}
        {showList && (
          <div className="dropdown-list">
            {isLoading ? (
              <div className="loading-state">
                <div className="spinner"></div>
                <p>Загрузка станков...</p>
              </div>
            ) : filteredList.length > 0 ? (
              filteredList.map((item) => (
                <div
                  className="machine-card"
                  key={item.id}
                  onClick={() => selectMachine(item)}  // СРАЗУ сохраняет при клике
                >
                  <div className="machine-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect x="3" y="12" width="18" height="8" rx="2" fill="#E8F0FE"/>
                      <circle cx="7" cy="16" r="2" fill="#265c9d"/>
                      <circle cx="17" cy="16" r="2" fill="#265c9d"/>
                      <rect x="10" y="6" width="4" height="6" fill="#94A3B8"/>
                    </svg>
                  </div>
                  <div className="machine-info">
                    <h3 className="machine-title">{item.name}</h3>
                    {/* <p className="machine-subtitle">Станок №{item.number}</p> */}
                  </div>
                  <div className="machine-badge">
                    {item.isActive ? '🟢 Активен' : '⚪ Неактивен'}
                  </div>
                </div>
              ))
            ) : (
              <div className="empty-state">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="#CBD5E1" strokeWidth="1.5"/>
                  <path d="M8 12H16" stroke="#CBD5E1" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
                <p>Станки не найдены</p>
                <span>Попробуйте изменить запрос</span>
              </div>
            )}
          </div>
        )}
      </div>
      
      {/* ПЛАШКА С ВЫБРАННЫМ СТАНКОМ — показывается СРАЗУ после выбора */}
      {stepOneData?.number ? (
        <div className="selected-machine">
          <div className="selected-card">
            <div className="selected-icon">🏭</div>
            <div className="selected-info">
              <h3>{stepOneData.name}</h3>
            </div>
            <div className="selected-check">✓</div>
          </div>
        </div>
      ) : step_input ? (
        /* Если номер введён, но ещё не проверен — показываем кнопку поиска */
        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <button 
            className="camera-button"
            onClick={handleInputSubmit}
            style={{ width: '100%' }}
          >
            🔍 Найти станок №{step_input}
          </button>
        </div>
      ) : null}
      
      {/* Кнопка Далее */}
      <button 
        className={`continue-button ${stepOneData?.number ? 'active' : ''}`}
        onClick={JobItem}
        disabled={!stepOneData?.number || isLoading}
      >
        {isLoading ? (
          <span className="button-spinner"></span>
        ) : (
          <>
            <span>Продолжить</span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </>
        )}
      </button>
    </div>
  );
}